module.exports = __webpack_public_path__ + "static/media/womenKianjavato.3ccec71a.jpg";